import * as AvatarPrimitive from "@radix-ui/react-avatar"
import clsx from "clsx"
import type { ReactNode } from "react"

import styles from "./Avatar.module.css"

export interface AvatarProps {
  imageUrl?: string
  firstName?: string
  lastName?: string
  hasBorder?: boolean
  size?: 16 | 24 | 32 | 40
  variant?: "circle" | "square"
  /**
   * The content to show when the imageUrl was not provided
   * or image is not available after delayMs.
   * If not provided, the initials of the first and last name will be shown.
   */
  fallback?: ReactNode
}

export function Avatar(props: AvatarProps) {
  const {
    imageUrl,
    firstName = "",
    lastName = "",
    hasBorder = true,
    size = 32,
    variant = "circle",
    fallback,
  } = props

  return (
    <AvatarPrimitive.Root
      className={clsx(
        styles.root,
        hasBorder && styles.border,
        styles[`size-${size}`],
        styles[`variant-${variant}`],
      )}
    >
      <AvatarPrimitive.Image src={imageUrl} className={styles.image} />
      <AvatarPrimitive.Fallback
        className={styles.fallback}
        delayMs={imageUrl ? 600 : undefined}
      >
        {fallback ?? getInitials(firstName, lastName)}
      </AvatarPrimitive.Fallback>
    </AvatarPrimitive.Root>
  )
}

function getInitials(firstName: string, lastName: string) {
  return (firstName.charAt(0) + lastName.charAt(0)).toUpperCase()
}
